// Home.jsx
import React from 'react';
import './Home.css'; // Adjust the path based on your project structure
import PostList from './PostList';

const Home = () => {
  return (
    <div className="home-container">
      <h1 className="big-title">Chart To Art</h1>
      <h2 className="handwriting close-subtitle" >
        <a href="http://www.bytesbysophie.com" target="_blank" rel="noreferrer">@BytesBySophie</a>
      </h2>
      <p className="description-text">
        This project is a creative data visualization challenge I came up with for myself in order to improve both, my creative coding and data communication skills.
        <br></br>Each week I will take a published statistic / chart and use its numbers as input parameter for a generative artwork.
        I will post the result on <a href="https://www.instagram.com/bytesbysophie" target="_blank" rel="noreferrer">Instagram</a> and here, where I will also link the original statistic / chart I have used as input.
      </p>
      <PostList />

    </div>
  );
};

export default Home;
